import { registerForms, registerRecordKinds, type FormDefinition, type RecordKindDefinition } from './registry.js';
import { basicInfoForm } from './caremanager/basic_info.js';
import { assessmentForm } from './caremanager/assessment.js';
import { careplan1Form } from './caremanager/careplan1.js';
import { careplan2Form } from './caremanager/careplan2.js';
import { careplan3Form } from './caremanager/careplan3.js';
import { careplan4Form } from './caremanager/careplan4.js';
import { supportProgressForm } from './caremanager/support_progress.js';
import { monitoringForm } from './caremanager/monitoring.js';
import { visitNoteKind } from './caremanager/records.js';

export * from './registry.js';
export * from './caremanager/common.js';
export * from './caremanager/basic_info.js';
export * from './caremanager/assessment.js';
export * from './caremanager/careplan1.js';
export * from './caremanager/careplan2.js';
export * from './caremanager/careplan3.js';
export * from './caremanager/careplan4.js';
export * from './caremanager/support_progress.js';
export * from './caremanager/monitoring.js';
export * from './caremanager/records.js';

// ケアマネの帳票（docType 順は様式の並び）
export const CAREMANAGER_FORMS: readonly FormDefinition[] = [
  basicInfoForm,
  assessmentForm,
  careplan1Form,
  careplan2Form,
  careplan3Form,
  careplan4Form,
  supportProgressForm,
  monitoringForm,
];

export const CAREMANAGER_RECORD_KINDS: readonly RecordKindDefinition[] = [visitNoteKind];

registerForms(CAREMANAGER_FORMS);
registerRecordKinds(CAREMANAGER_RECORD_KINDS);
